import ExcelJS from 'exceljs';
import { CargoEventReportData } from '../../ReportGeneratorTypes';
import { setCellValueWithFont, setupWorksheetForPrint, setWorksheetPrintArea } from './reportEventExcelUtils';
import {
    addCargoAndBerthDescription,
    addChartererAndDateTime,
    addOdfjellHeader,
    addVesselDetails,
    getCargoOperationForEvent,
    odfjellHeaderColor,
} from './parts/helpers';

const addReportHeader = (worksheet: ExcelJS.Worksheet, logoImageId: number) => {
    let rowNum = addOdfjellHeader(worksheet, logoImageId);
    rowNum = 6;
    setCellValueWithFont(worksheet, rowNum, 1, `PROTEST LETTER`, {
        bold: true,
        color: odfjellHeaderColor,
        fontSize: 16,
        mergeAcross: 9,
    });

    rowNum++;

    setCellValueWithFont(worksheet, rowNum, 1, `FOR USE OF VESSEL HOSES`, {
        bold: true,
        color: odfjellHeaderColor,
        fontSize: 16,
        mergeAcross: 9,
    });

    return rowNum + 1;
};

const addProtestPhrase = (worksheet: ExcelJS.Worksheet, rowNum: number) => {
    rowNum++;
    setCellValueWithFont(worksheet, rowNum, 1, 'On behalf of my disponent owners, I hereby protest against the use of vessel hoses.', {
        mergeAcross: 9,
        mergeDown: 2,
        verticalAlign: 'top',
        wrapText: true,
        align: 'left',
    });
    rowNum += 2;

    setCellValueWithFont(
        worksheet,
        rowNum,
        1,
        `I, Captain, as master of the vessel, hereby lodge protest accordingly, and we, including my disponent owners, hold you and/or Charterers responsible for delays and consequences.`,
        {
            mergeAcross: 9,
            mergeDown: 3,
            verticalAlign: 'top',
            wrapText: true,
            align: 'left',
        }
    );
    rowNum += 3;
    return rowNum;
};

const setDefaultColumnWidths = (workheet: ExcelJS.Worksheet) => {
    workheet.getColumn(1).width = 9;
    workheet.getColumn(2).width = 2;
    workheet.getColumn(3).width = 14;
    workheet.getColumn(4).width = 21;
    workheet.getColumn(5).width = 9;
    workheet.getColumn(6).width = 17;
    workheet.getColumn(7).width = 10;
    workheet.getColumn(8).width = 14;
    workheet.getColumn(9).width = 7;
};

export const generateProtestUseOfVesselHosesReport = (
    workbook: ExcelJS.Workbook,
    cargoEventReportData: CargoEventReportData,
    logoImageId: number
): void => {
    const _worksheet = workbook.addWorksheet('Use Of Vessel Hoses');
    setupWorksheetForPrint(_worksheet);
    // Hide gridlines and keep a clean white background
    _worksheet.views = [{ state: 'normal', showGridLines: false }];
    const portCall = cargoEventReportData.selectedPortCall;
    const selectedEvent = cargoEventReportData.tankersEvents.find((ev) => !ev.deleted && ev.eventId === cargoEventReportData.excelReportInfo.eventId);
    const cargoOperation = getCargoOperationForEvent(
        portCall.berthCalls.flatMap((berthCall) => berthCall.cargoOperations),
        selectedEvent
    );
    if (!cargoOperation || !selectedEvent) return;
    setDefaultColumnWidths(_worksheet);
    addReportHeader(_worksheet, logoImageId);
    let rowNum = addVesselDetails(
        _worksheet,
        9,
        1,
        7,
        portCall.voyageNumber,
        portCall.portDisplayName,
        cargoEventReportData.vessel,
        selectedEvent.cargoNumber,
        selectedEvent.eventDate.actualDateTimeLocal
    );
    rowNum = addCargoAndBerthDescription(_worksheet, cargoOperation, rowNum + 3);
    rowNum = addProtestPhrase(_worksheet, rowNum + 2);
    const endRow = addChartererAndDateTime(_worksheet, rowNum + 8, cargoOperation, selectedEvent, 'Master/Agent');
    // Set print area to A1 through I:endRow so scaling fills the page vertically
    setWorksheetPrintArea(_worksheet, endRow, 9, 1, 1);
};
